'use client';

import { Slot } from 'radix-ui';
import type { ComponentPropsWithRef } from 'react';

import { cn } from '~/components/lib/utils';
import { Button } from '~/components/shadcn/Button';
import { Tooltip, TooltipContent, TooltipTrigger } from '~/components/shadcn/Tooltip';

export type TooltipIconButtonProps = ComponentPropsWithRef<typeof Button> & {
	tooltip: string;
	side?: 'top' | 'bottom' | 'left' | 'right';
};

export const TooltipIconButton = ({ children, tooltip, side = 'bottom', className, ref, ...rest }: TooltipIconButtonProps) => {
	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<Button variant="ghost" size="icon" {...rest} className={cn('aui-button-icon size-6 p-1', className)} ref={ref}>
					<Slot.Slottable>{children}</Slot.Slottable>
					<span className="aui-sr-only sr-only">{tooltip}</span>
				</Button>
			</TooltipTrigger>
			<TooltipContent side={side}>{tooltip}</TooltipContent>
		</Tooltip>
	);
};
